import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  createProfileService,
  deleteProfileService,
  updateProfileService,
} from '@/services/httpServices/ProfileServices';
import type {
  CreateProfileServiceConfig,
  DeleteProfileServiceConfig,
  UpdateProfileServiceConfig,
} from '@/services/httpServices/ProfileServices/types';

import { profileListKeys } from '../queries/profileQueryKeys';

export function useCreateProfileMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: CreateProfileServiceConfig) => {
      try {
        return await createProfileService(config);
      } catch (error) {
        throw new Error(
          error instanceof Error ? error.message : 'Unknown error',
        );
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: profileListKeys(),
      });
    },
  });
}

export function useUpdateProfileMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: UpdateProfileServiceConfig) => {
      try {
        return await updateProfileService(config);
      } catch (error) {
        throw new Error(
          error instanceof Error ? error.message : 'Unknown error',
        );
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: profileListKeys(),
      });
    },
  });
}

export function useDeleteProfileMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: DeleteProfileServiceConfig) => {
      try {
        await deleteProfileService(config);
      } catch (error) {
        throw new Error(
          error instanceof Error ? error.message : 'Unknown error',
        );
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: profileListKeys(),
      });
    },
  });
}
